'use strict';

import template from './system_alerts.html';

export default {
  template: template,
  controller: function($scope, systemAlerts) {
    'ngInject';

    this.systemAlerts = systemAlerts;

    this.dismiss = () => {
      systemAlerts.dismiss();
    };
  },
};



// WEBPACK FOOTER //
// ./app/src/components/system_alerts/system_alerts.js